export default __webpack_public_path__ + "static/1869-13a1d74187c2e8c408edcc2b711cba7b.gif";